import PaymentService from "../../service/PaymentService";

export const namespaced = true;

export const state = {
  showPaymentsReceivedModal: false,
  paymentStatus: "not-received",
  paymentCheckLoading: false,
  paymentMessage: ""
};

export const getters = {};

export const mutations = {
  SET_SHOW_PAYMENT_RECEIVED_MODAL(state, status) {
    state.showPaymentsReceivedModal = status;
  },
  SET_PAYMENT_CHECK_LOADING(state, status) {
    state.paymentCheckLoading = status;
  },
  PAYMENT_RECEIVED(state) {
    state.paymentStatus = "received";
  },
  PAYMENT_NOT_RECEIVED(state) {
    state.paymentStatus = "not-received";
  },
  SET_PAYMENT_MESSAGE(state, message) {
    state.paymentMessage = message;
  }
};
export const actions = {
  showPaymentsReceivedModal({ commit }, status) {
    commit("SET_SHOW_PAYMENT_RECEIVED_MODAL", status);
  },

  checkPaymentStatus({ commit, rootGetters, dispatch }) {
    dispatch("loader/showNonBlockingLoader", true, { root: true });
    let payload = {
      accountNumber: rootGetters["donation/getWalletAccountNumber"]
    };
    return PaymentService.checkPaymentStatus(payload)
      .then(response => {
        dispatch("loader/showNonBlockingLoader", false, { root: true });
        let responseData = response.data;
        if (responseData.responsecode === "00") {
          commit("PAYMENT_RECEIVED");
          commit("SET_PAYMENT_MESSAGE", responseData.responsemessage);
        } else if (responseData.responsecode === "20") {
          commit("PAYMENT_NOT_RECEIVED");
          commit("SET_PAYMENT_MESSAGE", responseData.responsemessage);
        }
        return responseData;
      })
      .catch(error => {
        dispatch("loader/showNonBlockingLoader", false, { root: true });

        const notification = {
          type: "error",
          message: `Error: Network Error Please Try Again`
        };
        dispatch("notification/add", notification, { root: true });
        throw error;
      });
  }
};
